import { graphql } from 'react-relay';
import { useTranslation } from '@/helpers/translate';

const query = graphql`
  fragment cancelPolicySpace_policy on Policy {
    slug
    rules {
      payback
      when
    }
  }
`;

export default function CancelPolicy({ policy }) {
  const { t } = useTranslation();
  if (!policy) return null;
  return (
    <section className="flex-col mt-12 md:mt-12 text-purple-5/70 md:flex-row">
      <h2 className="w-full pt-6 pb-2 border-t border-white-dark2 md:pt-12 m-0 font-heading text-[14px] font-extrabold uppercase leading-[1.2] tracking-[0.02em] text-was-ink md:text-[15px]">{t('space:cancelation_policy')}</h2>
      <div className="flex flex-col my-2 md:flex-row">
        <div className="pb-4 md:pb-0 md:mr-6">
          <div className="px-4 py-2 font-medium border rounded-lg text-purple-6 border-purple-1">{t(`booking:policies.${policy.slug}`)}</div>
        </div>
        <p>{t('booking:policies.details', { count: policy?.rules?.[0]?.when, pourcent: policy?.rules?.[0].payback })}</p>
      </div>
    </section>
  );
}
